import { magenta, red } from "@ant-design/colors";
import { Button } from "antd";
import { darken } from "polished";
import styled from "styled-components";

export const transitionTime = 250;
const headerHeight = 60;
const paddingLeft = 30;
const paddingTop = 10;
const borderPx = 2;
const borderRadius = 5;
const hoverTextColor = "#fff";

export const StyledAddNewMessageButton = styled(Button)`
  @media screen and (max-width: 768px) {
    span:nth-child(2) {
      display: none;
    }
  }
`;

export const StyledCollapseContainer = styled.div`
  width: 100%;
  height: auto;
  overflow: auto;
  transition: all ${transitionTime}ms ease-in-out;

  > .Collapse {
    margin-bottom: 10px;
    margin-left: -${paddingLeft}px;
  }

  > .Collapse > .Collapse-Header > .Collapse-Header-Border {
    display: none !important;
  }

  .Collapse-Body
    > .Collapse:last-child
    > .Collapse-Header
    > .Collapse-Header-Border {
    display: none !important;
  }

  .Collapse-Empty > .Collapse-Border {
    display: none !important;
  }

  > .Collapse-Add {
    margin-left: 0 !important;
  }
`;

export const StyledCollapse = styled.div`
  border-radius: ${borderRadius}px;
  color: #000;
  position: relative;
  overflow: hidden;
  height: auto;
  display: grid;
  padding-left: ${paddingLeft}px;

  &.Collapsed {
    > .Collapse-Border {
      display: block;
    }

    > .Collapse-Header {
      z-index: 1;

      .Collapse-Header-Icon {
        transform: rotate(90deg);
      }
    }

    > .Collapse-Body {
      height: auto !important;
      padding-top: ${paddingTop}px;
      grid-template-rows: 1fr !important;

      > .Empty {
        width: 100%;
        padding: 10px !important;
        margin: 0 !important;
        margin-bottom: 10px !important;
        margin-left: ${paddingLeft}px !important;
        border-radius: ${borderRadius}px;
        border: 1px solid ${({ theme }) => theme.palette.borderColor};
      }
    }
  }
`;

export const StyledCollapseBorder = styled.div`
  width: 100%;
  height: 100%;
  bottom: ${headerHeight / 2 + paddingTop}px;
  left: ${paddingLeft + 2}px;
  display: none;
  position: absolute;
  transition: all ${transitionTime}ms ease-in-out;

  &::before {
    content: "";
    border: ${borderPx}px solid ${() => magenta[6]};
    border-right: none;
    border-top: none;
    border-bottom-left-radius: 10px;
    display: block;
    width: 30px;
    height: calc(100%);
    position: absolute;
    left: 0px;
  }
`;

export const StyledCollapseHeader = styled.div`
  border-radius: ${borderRadius}px;
  padding: 10px;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.background.default};
  color: ${({ theme }) => theme.palette.text.primary};
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  margin-bottom: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  transition: all ${transitionTime}ms ease-in-out;

  &:hover {
    color: ${hoverTextColor};

    .Collapse-Header-Buttons {
      margin-right: 0;
    }

    &:has(.Collapse-Header-Edit) {
      background-color: #fff !important;
    }
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 7px;
    height: 100%;
    background-color: ${() => red[6]};
    border-top-left-radius: ${borderRadius}px;
    border-bottom-left-radius: ${borderRadius}px;
  }

  &.Active {
    background-color: ${({ theme }) => theme.palette.background.default};
    color: ${hoverTextColor};
    transition: ${transitionTime}ms all linear;

    .Collapse-Header-Buttons {
      margin-right: 0;
    }
  }

  &:hover::before {
    width: 100%;
    transition: all ${transitionTime}ms ease-in-out;
  }

  &.Collapse-Header-Edit {
    background-color: ${({ theme }) =>
      theme.palette.background.default} !important;
  }

  &.Collapse-Header-Edit:hover {
    background-color: ${({ theme }) =>
      darken(0.1, theme.palette.background.default)} !important;
  }

  &.Collapse-Header-Edit::before {
    width: 10px;
  }

  &.Collapse-Header-Edit:hover::before {
    width: 55px;
  }

  .Collapse-Header-Buttons {
    position: absolute;
    right: 10px;
    margin-right: -140px;
    transition: ${headerHeight}px all linear;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;

    &.Active {
      margin-right: 0px;
    }
  }

  .Collapse-Header-Icon {
    position: relative !important;
    width: 40px;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const StyledCollapseHeaderContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap: 0px;
  position: relative;
  z-index: 1;
  pointer-events: none;

  span:nth-child(1) {
    font-weight: bold;
  }
`;

export const StyledCollapseHeaderBorder = styled.div`
  position: absolute;
  width: ${paddingLeft - 2}px;
  height: 2px;
  background-color: ${() => red[6]};
  top: ${headerHeight / 2}px;
  left: -${paddingLeft - 2}px;
`;

export const StyledCollapseHeaderButtons = styled.div`
  position: absolute;
  z-index: 2;
  right: 10px;
  margin-right: -140px;
  transition: ${transitionTime}ms all linear;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

export const StyledCollapseHeaderIcon = styled.div`
  position: relative !important;
  width: 40px;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledCollapseBody = styled.div`
  padding: 0;
  overflow: hidden;
  display: grid;
  height: 0;
  grid-template-rows: 0fr;
  transition:
    height ${transitionTime}ms ease-in-out,
    grid-template-rows ${transitionTime}ms ease-in-out;
`;

export const StyledCollapseAdd = styled.div<{ status?: boolean }>`
  margin-top: ${paddingTop}px;
  margin-bottom: ${paddingTop}px;
  margin-left: ${paddingLeft}px;
  border: 2px dashed ${() => red[6]};
  transition: all ${transitionTime}ms ease-in-out;
  border-radius: ${borderRadius}px;
  padding: 10px;
`;

export const StyledOptionsContainer = styled.div<{ isDragging?: boolean }>`
  display: flex;
  align-items: center;
  background-color: ${({ theme, isDragging }) =>
    isDragging
      ? darken(0.1, theme.palette.background.default)
      : theme.palette.background.default};
  padding: 4px;
  border-radius: 4px;
  cursor: move;
  border: ${({ isDragging, theme }) =>
    isDragging ? `1px solid ${theme.palette.borderColor}` : "none"};
`;
